import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router'

const RestrictedRoute = ({ type, is_authenticated, component: Component, ...rest }) => {
  return (
    <Route 
      {...rest} 
      render={props => {
        console.debug(props, type, is_authenticated)
        if ((is_authenticated && type === 'private') || (!is_authenticated && type === 'public')) {
          return <Component {...props} />
        } else {
          return <Redirect to={{
            pathname: type === 'private' ? `/auth/login` : (props.location.state ? props.location.state.from.pathname : '/'),
            search: `from=${props.location.pathname}`,
            state: { from: props.location }
          }} />
        }
    }} />
  )
}

RestrictedRoute.propTypes = {
  is_authenticated: PropTypes.bool.isRequired
}

export default connect(state => ({
  is_authenticated: state.auth.is_authenticated
}))(RestrictedRoute)


// WEBPACK FOOTER //
// ./src/containers/RestrictedRoute/RestrictedRoute.js